<template>
  <div id="app">
    <div>
      <theme-switcher />
      <hello-world />
    </div>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import ThemeSwitcher from "./components/ThemeSwitcher.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
    ThemeSwitcher,
  },
};
</script>

<style>
@import "./styles/theme-vars.css";

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  background-color: var(--bg-color);
  color: var(--font-color);
  margin: 0 auto;
  font-size: calc(1rem + 0.25vh);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.mr-15 {
  margin-right: 15px;
}
.ml-15 {
  margin-left: 15px;
}
.m15 {
  margin: 15px;
}

.pull-right {
  float: right;
}
.full-width {
  width: 100%;
}
</style>
